import { ParamKeyValuePair } from 'react-router-dom';
import { DataFilterDateRangeValue } from '@asset-metrix/portal-gateway-client-js';

import { FilterSelections } from '../store/states/filterSelection';
import { FilterConfigDto } from '../store/states/filterTypes';

export function selectionToKeyValuePairs(
  key: string,
  selection: unknown
): ParamKeyValuePair[] {
  if (selection == null) {
    return [];
  }
  if (Array.isArray(selection)) {
    return selection.map((v) => [key, String(v)]);
  }
  if (
    typeof selection === 'object' &&
    ('start' in (selection as Record<string, unknown>) ||
      'end' in (selection as Record<string, unknown>))
  ) {
    const value = selection as DataFilterDateRangeValue;
    return [
      [
        key,
        JSON.stringify({
          ...(value.start != null ? { gte: value.start } : {}),
          ...(value.end != null ? { lte: value.end } : {}),
        }),
      ],
    ];
  }
  return [[key, String(selection)]];
}

export function selectionsToKeyValuePairs(
  selections: FilterSelections,
  configs: FilterConfigDto[],
  transformKey: (key: string) => string = (key) => key
): ParamKeyValuePair[] {
  const pairs: ParamKeyValuePair[] = [];
  for (const config of configs) {
    const selection = selections[config.key];
    if (selection != null) {
      pairs.push(
        ...selectionToKeyValuePairs(transformKey(config.key), selection)
      );
    }
  }
  return pairs;
}
